import React from "react";
import { Navigate } from "react-router-dom";
import PrivateRoute from "./utils/PrivateRoute";
import ViewAccount from "./pages/accounts/ViewAccount";
import TaskView from "./pages/tasks/TaskView";
import LeadsReport from "./components/reports/LeadsReport";
import AdminPanel from "./components/AdminPanel";

import { Dashboards } from "./components/Dashboards";
import Companies from "./pages/Companies";
// import { UnifiedClientCompany } from "./components/UnifiedClientCompany";
import { DocumentCenter } from "./components/DocumentCenter";
// import { WorkflowManagement } from "./components/WorkflowManagement";
import { ReportsAnalytics } from "./components/ReportsAnalytics";
import { ComplianceCalendar } from "./components/ComplianceCalendar";
import { TDSManagement } from "./components/TDSManagement";
import { InvoiceGenerator } from "./components/InvoiceGenerator";
import BoardResolution from "./components/documentTemplates/BoardResolution";
import AOA from "./components/documentTemplates/AOA";
import MOA from "./components/documentTemplates/MOA";
import COI from "./components/documentTemplates/COI";
import Template from "./screen/Template";
import ProfilePage from "./components/ProfilePage";
import { UnifiedClientCompany } from "./pages/accounts/UnifiedClientCompany";
import { WorkflowManagement } from "./pages/Workflow/WorkflowManagement";
import Bsheet from "./pages/reports/Bsheet";
import ProfitAndLoss from "./pages/reports/ProfitAndLoss";
import ClientManagement from "./pages/accounts/ClientManagement";
import AccountDetails from "./pages/test/AccountDetails";
import WorkFlowTemplate from "./pages/workflowTemplates/WorkFlowTemplate";
import NotFound from "./screen/NotFound";
import { UserManagement } from "./components/users/UserManagement";
import RegistrationFormList from "./pages/accounts/RegistrationFormList";
import RegisterFormRouter from "./pages/accounts/RegistrationForm/RegisterFormRouter";
import Invoice from "./components/invoice/Invoice";
import Organization from "./pages/organization/Organization";
import ClientDetails from "./pages/accounts/ClientDetails";
import Test from "./pages/test/Test";
import AddWorkflowAll from "./components/workflow/AddWorkflowAll";
import ViewWorkflow from "./components/workflow/ViewWorkflow";
import AddTasksAll from "./components/task/AddTasksAll";
import EmailSchedules from "./pages/email/EmailSchedules";
import EmailHistory from "./pages/email/EmailHistory";
import ScheduleForm from "./components/email/ScheduleForm";
import EmailTemplateManager from "./components/email/EmailTemplateManager";
import NotificationSettings from "./pages/compliance/NotificationSettings";
import ComplianceTracker from "./pages/compliance/ComplianceTracker";

const SignIn = React.lazy(() => import("./pages/authentication/SignIn"));
const Leads = React.lazy(() => import("./pages/leads/Leads"));
const AddLeads = React.lazy(() => import("./pages/leads/AddLeads"));
const AddAccounts = React.lazy(() => import("./pages/accounts/AddAccounts"));
const Accounts = React.lazy(() => import("./pages/accounts/Accounts"));
const AddTasks = React.lazy(() => import("./pages/tasks/AddTasks"));
const Tasks = React.lazy(() => import("./pages/tasks/Tasks"));
// const Meetings = React.lazy(() => import("./pages/meetings/Meetings"));
const Meetings = React.lazy(() => import("./pages/meetings/Meetings"));

const CreateMeeting = React.lazy(() => import("./pages/meetings/CreateMeeting"));
const Reports = React.lazy(() => import("./pages/reports/Reports"));

const auth_routes = [
    { path: "/", element: <SignIn /> },

    { path: "/", element: <Navigate to="/signin" /> },
    { path: "*", element: <NotFound /> }
];

const routes = [

    {
        path: "/leads/createleads",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <AddLeads />
            </PrivateRoute>
        ),
    },
    {
        path: "/leads/edit-leads/:leadsId",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <AddLeads />
            </PrivateRoute>
        ),
    },
    {
        path: "/leads",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <Leads />
            </PrivateRoute>
        ),
    },

    {
        path: "/test",
        element: (
            <PrivateRoute roles={["ADMIN"]}>
                <Test />
            </PrivateRoute>
        ),
    },
    {
        path: "/accounts/createAccounts",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <AddAccounts />
            </PrivateRoute>
        ),
    },
    {
        path: "/register/:id",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <RegisterFormRouter />
            </PrivateRoute>
        ),
    },
    {
        path: "/accounts/ClientManagement",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <ClientManagement />
            </PrivateRoute>
        ),
    },
    {
        path: "/accounts/edit-accounts/:accountsId",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <AddAccounts />
            </PrivateRoute>
        ),
    }, {
        path: "/accounts/view/:accountsId",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <ViewAccount />
                {/* <ClientDetails/> */}
            </PrivateRoute>
        ),
    },
    {
        path: "/client-management",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <Accounts />
            </PrivateRoute>
        ),
    },
    {
        path: "/tasks/createTasks",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                {/* <AddTasks /> */}
                <AddTasksAll/>
            </PrivateRoute>
        ),
    },
    {
        path: "/tasks/edit-task/:taskId",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                {/* <AddTasks /> */}
                <AddTasksAll/>
            </PrivateRoute>
        ),
    },
    {
        path: "/tasks/view/:taskId",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <TaskView />
            </PrivateRoute>
        ),
    },
    {
        path: "/tasks",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <Tasks />
            </PrivateRoute>
        ),
    },
    {
        path: "/meetings/createMeeting",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <CreateMeeting />
            </PrivateRoute>
        ),
    },
    {
        path: "/meetings",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <Meetings />
            </PrivateRoute>
        ),
    },
    {
        path: "/leads/reports",
        element: (
            <PrivateRoute roles={["ADMIN", "USER"]}>
                <LeadsReport />
            </PrivateRoute>
        ),
    },
    {
        path: "/reports-analytics",
        element: (
            <PrivateRoute roles={["ADMIN"]}>
                <ReportsAnalytics />
            </PrivateRoute>
        ),
    },
    {
        path: "/reports",
        element: (
            <PrivateRoute roles={["ADMIN"]}>
                <Reports />
            </PrivateRoute>
        ),
    },
    {
        path: "/bsheet",
        element: (
            <PrivateRoute roles={["ADMIN"]}>
                <Bsheet />
            </PrivateRoute>
        ),
    },
    {
        path: "/profit-and-loss",
        element: (
            <PrivateRoute roles={["ADMIN"]}>
                <ProfitAndLoss />
            </PrivateRoute>
        ),
    },
    {
        path: "/ADMIN-panel",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <AdminPanel />
            </PrivateRoute>
        ),
    },
    {
        path: "/advancedGSTFeatures",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <Companies />
            </PrivateRoute>
        ),
    },
    {
        path: "/dashboard",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <Dashboards />
            </PrivateRoute>
        ),
    },
    {
        path: "/client-management",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <UnifiedClientCompany />
            </PrivateRoute>
        ),
    },
    {
        path: "/registration-form-list",
        element: (
            <PrivateRoute roles={["ADMIN"]}>
                <RegistrationFormList />
            </PrivateRoute>
        ),
    },
    {
        path: "/document-center",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <DocumentCenter />
            </PrivateRoute>
        ),
    },
    {
        path: "/workflows",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <WorkflowManagement />
            </PrivateRoute>
        ),
    },
    {
        path: "/workflows/template",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <WorkFlowTemplate />
            </PrivateRoute>
        ),
    },
    {
        path: "/create/workflows",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <AddWorkflowAll />
            </PrivateRoute>
        ),
    },
    {
        path: "/create/workflows/:id",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <AddWorkflowAll />
            </PrivateRoute>
        ),
    },
    {
        path: "/workflows/view/:id",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <ViewWorkflow />
            </PrivateRoute>
        ),
    },

    {
        path: "/compliance-calendar",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <ComplianceCalendar />
            </PrivateRoute>
        ),
    },

    {
        path: "/USER-management",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <UserManagement />
            </PrivateRoute>
        ),
    },
    {
        path: "/organization",
        element: (
            <PrivateRoute roles={["ADMIN"]}>
                <Organization />
            </PrivateRoute>
        ),
    },
    {
        path: "/subscription",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <AdminPanel />
            </PrivateRoute>
        ),
    },
    {
        path: "/settings",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <AdminPanel />
            </PrivateRoute>
        ),
    },
    {
        path: "/tds-management",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <TDSManagement />
            </PrivateRoute>
        ),
    },
    {
        path: "/invoice-generator",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <InvoiceGenerator />
            </PrivateRoute>
        ),
    },
    {
        path: "/invoice",
        element: (
            <PrivateRoute roles={["ADMIN"]}>
                <Invoice />
            </PrivateRoute>
        ),
    },
    // <=============Email=========================>
    {
        path: "/email/templates",
        element: (
            <PrivateRoute roles={['ADMIN']}>
                <EmailTemplateManager />
            </PrivateRoute>
        ),
    },
    {
        path: "/email/schedules",
        element: (
            <PrivateRoute roles={['ADMIN','USER']}>
                <EmailSchedules />
            </PrivateRoute>
        ),
    },
    {
        path: "/create/email/schedules",
        element: (
            <PrivateRoute roles={['ADMIN','USER']}>
                <ScheduleForm />
            </PrivateRoute>
        ),
    },
    {
        path: "/email/history",
        element: (
            <PrivateRoute roles={['ADMIN','USER']}>
                <EmailHistory />
            </PrivateRoute>
        ),
    },
    // <=============Compliance=========================>
    {
        path: "/compliance/tracker",
        element: (
            <PrivateRoute roles={['ADMIN','USER']}>
                <ComplianceTracker />
            </PrivateRoute>
        ),
    },
    {
        path: "/compliance/notifications",
        element: (
            <PrivateRoute roles={['ADMIN','USER']}>
                <NotificationSettings />
            </PrivateRoute>
        ),
    },
    // {
    //     path: "/letter-head",
    //     element: (
    //         <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
    //             <LetterHead />
    //         </PrivateRoute>
    //     ),
    // },
    {
        path: "/certificate-of-incorporation",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <COI />
            </PrivateRoute>
        ),
    },
    {
        path: "/memorandum-of-association",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <MOA />
            </PrivateRoute>
        ),
    },
    {
        path: "/articles-of-association ",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                < AOA />
            </PrivateRoute>
        ),
    },
    {
        path: "/board-resolution",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <BoardResolution />
            </PrivateRoute>
        ),
    },
    {
        path: "/documentation",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <Template />
            </PrivateRoute>
        ),
    },
    {
        path: "/profile",
        element: (
            <PrivateRoute roles={["ADMIN", "USER", "CUSTOMER"]}>
                <ProfilePage />
            </PrivateRoute>
        ),
    },


];

export { auth_routes, routes };
